import React from 'react'
import { ServiceContainer, ServiceH1, ServicesWrapper, ServicesCard, ServicesIcon, ServicesH2, ServicesP, Sera } from './CitizenElements'

const Citizen = () => {
    return (
        <ServiceContainer id="projects">
            <ServicesH2>CITIZENSHIP</ServicesH2>
            
                <ServicesWrapper>
                    <ServicesCard >
                    {/* <a href="https://imgur.com/eMpFivL"><img src="https://i.imgur.com/eMpFivL.png" title="source: imgur.com" /></a> */}
                        <ServicesIcon src="https://i.imgur.com/eMpFivL.png" />             
                        <ServiceH1>The DNMS  Journal</ServiceH1>          
                        <ServicesP>All the comic inspiration comes from your participation on the journey and in the community. We will be creating a universe that belongs to every DNMS citizen.</ServicesP>
                    </ServicesCard>

                    <ServicesCard  >
                    {/* <a href="https://imgur.com/nteiioJ"><img src="https://i.imgur.com/nteiioJ.png" title="source: imgur.com" /></a> */}
                        <ServicesIcon src="https://i.imgur.com/nteiioJ.png"  />
                        <ServiceH1>Private Islands</ServiceH1>   
                        <ServicesP>There are four islands in the Dinomension – Ace, Muse, Wanderer, and Da Kine. Each citizen will gain access to the one marked on their ID card (metadata).</ServicesP>
                    </ServicesCard>

                    <ServicesCard  >
                    {/* <a href="https://imgur.com/r2mefgE"><img src="https://i.imgur.com/r2mefgE.png" title="source: imgur.com" /></a> */}
                        <ServicesIcon src="https://i.imgur.com/r2mefgE.png"  />
                        <ServiceH1>Drops And Events</ServiceH1>   
                        <ServicesP>DNMS citizens will be able to participate in the roadmap events and receive exclusive NFT and merch drops. </ServicesP>
                    </ServicesCard>

                    <ServicesCard  >
                    {/* <a href="https://imgur.com/JvootqK"><img src="https://i.imgur.com/JvootqK.png" title="source: imgur.com" /></a> */}
                        <ServicesIcon src="https://i.imgur.com/JvootqK.png" />
                        <ServiceH1>Permanent Membership</ServiceH1>   
                        <ServicesP>All the NFT holders will be part of DNMS’s future plannings and will get a permanent membership.</ServicesP>
                    </ServicesCard>
                </ServicesWrapper>
            
        </ServiceContainer>
    )
}

export default Citizen
